// =====================================
//  編輯臨櫃匯款資訊 modal
//
//  @author: Gray
//  @time 2016 / 09 / 28
// =====================================

window.InifECMobileApp.directive('editRemittanceInfo', ['$rootScope', '$ngModal', '$timeout',
    function ($rootScope, $ngModal, $timeout) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // -------------------------------
            // 更改臨櫃匯款資訊
            // -------------------------------
            var submit = function() {

                $scope.isCodeEmpty = false;
                $scope.isNameEmpty = false;
                $scope.isPhoneEmpty = false;
                $scope.isDateEmpty = false;
                $scope.isTimeEmpty = false;

                // 檢查資料是否有正確填入
                var isError = false;
                var result = {
                    remittanceCode: undefined,
                    remittanceName: undefined,
                    remittancePhone: undefined,
                    remittanceDate: undefined,
                    remittanceTime: undefined,
                    hasCode: $scope.form.hasCode,
                };

                if(result.hasCode) {

                    if(!$scope.form.remittanceCode) {
                        $scope.isCodeEmpty = true;
                        isError = true;
                    }

                    result.remittanceCode = $scope.form.remittanceCode;

                } else {
                    if(!$scope.form.remittanceName) {
                        $scope.isNameEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.remittancePhone) {
                        $scope.isPhoneEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.remittanceDate) {
                        $scope.isDateEmpty = true;
                        isError = true;
                    }

                    if(!$scope.form.remittanceTime) {
                        $scope.isTimeEmpty = true;
                        isError = true;
                    }

                    result.remittanceName = $scope.form.remittanceName;
                    result.remittancePhone = $scope.form.remittancePhone;
                    result.remittanceDate = $scope.form.remittanceDate;
                    result.remittanceTime = $scope.form.remittanceTime;
                }

                if(isError) {
                    return;
                }
                
                $scope.callback && $scope.callback(result);

                closeModal();
            }

            // -------------------------------
            // 更改匯款方式
            // -------------------------------
            var changeType = function(hasCode) {

                $scope.form.hasCode = hasCode;
            }

            // -------------------------------
            // 離開編輯運送方式
            // -------------------------------
            var cancel = function() {

                closeModal();
            }

            // -------------------------------
            // [private] 開啟 modal
            // -------------------------------
            var openModal = function() {

                $ngModal.openModal('edit-remittance-info-modal');
            }

            // -------------------------------
            // [private] 關閉 modal
            // -------------------------------
            var closeModal = function() {

                $ngModal.closeModal('edit-remittance-info-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_EDIT_REMITTANCE_INFO_MODAL', function(event, data) {
                
                if(data) {

                    $scope.form.remittanceName = data.remittanceName;
                    $scope.form.remittanceCode = data.remittanceCode;
                    $scope.form.remittancePhone = data.remittancePhone;
                    $scope.form.remittanceDate = data.remittanceDate;
                    $scope.form.remittanceTime = data.remittanceTime;
                    $scope.form.hasCode = data.hasCode;

                    $scope.isCodeEmpty = false;
                    $scope.isNameEmpty = false;
                    $scope.isPhoneEmpty = false;
                    $scope.isDateEmpty = false;
                    $scope.isTimeEmpty = false;

                    $scope.callback = data.callback;

                    openModal();
                }
            });

            /*==========================
                Members
            ==========================*/
            $scope.form = {
                remittanceName: '',
                remittanceCode: '',
                remittancePhone: '',
                remittanceDate: '',
                remittanceTime: '',
                hasCode: true,
            }

            $scope.isCodeEmpty = false;
            $scope.isNameEmpty = false;
            $scope.isPhoneEmpty = false;
            $scope.isDateEmpty = false;
            $scope.isTimeEmpty = false;
            
            /*==========================
                Methods
            ==========================*/
            $scope.changeType = changeType; // 更改匯款方式
            $scope.submit = submit; // 更改運送資訊
            $scope.cancel = cancel; // 離開編輯運送方式
            $scope.callback = undefined;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/edit_remittance_info.html";
        _dir.controller = controller;

        return _dir;
    }]
);